import { clone } from '@jack-henry/frontend-utils/functions';
import { FilterBaseModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';
import { nullFilterBaseModelDto } from './report-list-item.entity';

export class ReportMetaData extends DomainEntity<FilterBaseModelDto> {
    constructor(dto = clone(nullFilterBaseModelDto)) {
        super(dto);
        this.dto = dto;
    }

    public createDefault(): this {
        return new ReportMetaData(this.dto) as this;
    }

    public get name() {
        return this.dto.name || '';
    }

    public set name(value: string) {
        this.dto.name = value;
    }

    public get reportType() {
        return this.dto.reportType || '';
    }

    public get isStandardReport() {
        return this.dto.isStandardReport || false;
    }

    public get dateType() {
        return this.dto.dateType || '';
    }

    public get fromDate() {
        return this.dto.fromDate || undefined;
    }

    public get toDate() {
        return this.dto.toDate || undefined;
    }

    public get specificDate() {
        return this.dto.specificDate || undefined;
    }

    public get sortBy() {
        return this.dto.sortBy || '';
    }

    public get isAscendingSort() {
        return this.dto.isAscendingSort || false;
    }

    public get accountTypes() {
        return this.dto.accountTypes?.split(',') || '';
    }

    public get accounts() {
        return this.dto.accounts || undefined;
    }

    public get type() {
        return this.dto.type || '';
    }

    public get id() {
        return this.dto.id || 0;
    }
}
